import {  Radio, RadioGroup, Stack } from "@chakra-ui/react";
import React from 'react';


export default function HorariosListButtons(props) {
    return (
        <>
            <div className="card-horario">
                <div className="top-card"><span>Horários disponíveis</span></div>
                <RadioGroup className="radio-butons" onChange={props.changeHorarios} value={props.valor} color={'black'} pt={'.725rem'} >
                    <Stack direction='column' flexFlow={'wrap'} maxH={'100%'} width={'400px'} justifyContent={'center'} alignContent={'flex-start'}  >
                        {props.horarios.map((e,key) =>
                            <Radio alignSelf={'self-starts'} p={'3px'} m={'0px!important'} size='md' value={e.Horario} key={key} colorScheme='red'>{e.Horario}</Radio>
                        )}
                    </Stack>
                </RadioGroup>
            </div>
        </>

    )
}